export default __webpack_public_path__ + "static/media/bioengg-bioengg-icon.7021a290.svg";